import { Paper, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import GroupIcon from "@mui/icons-material/Group";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import VerifiedIcon from "@mui/icons-material/Verified";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { formatInteger, formatPercent } from "../../../../../formatters";

const PRIMARY = "#8E24AA";

interface UsersKpiCardsProps {
  total: number;
  leads: number;
  qualified: number;
}

// Mobile-specific 2-per-row KPI grid (mockup: 2x2), same values/calculations
// as the desktop UsersKpiCards.tsx (checklist Section 10.4).
export default function UsersKpiCards({ total, leads, qualified }: UsersKpiCardsProps) {
  const conversion = total ? (qualified / total) * 100 : 0;

  return (
    <Grid container spacing={1.25}>
      <Grid size={6}>
        <Paper variant="outlined" sx={{ p: "13px 14px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1, fontSize: 11 }}>
              TOTAL USERS
            </Typography>
            <GroupIcon sx={{ color: PRIMARY, fontSize: 18 }} />
          </Stack>
          <Typography fontWeight={700} sx={{ mt: 0.75, fontSize: 25, color: "#1a1a1a", lineHeight: 1.1 }}>
            {formatInteger(total)}
          </Typography>
          <Typography sx={{ color: "#9e9e9e", fontSize: 11, display: "block", mt: 0.5 }}>
            entered the funnel
          </Typography>
        </Paper>
      </Grid>

      <Grid size={6}>
        <Paper variant="outlined" sx={{ p: "13px 14px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1, fontSize: 11 }}>
              LEADS
            </Typography>
            <HowToRegIcon sx={{ color: "#5B9BD5", fontSize: 18 }} />
          </Stack>
          <Typography fontWeight={700} sx={{ mt: 0.75, fontSize: 25, color: "#1a1a1a", lineHeight: 1.1 }}>
            {formatInteger(leads)}
          </Typography>
          <Typography sx={{ color: "#9e9e9e", fontSize: 11, display: "block", mt: 0.5 }}>
            completed contact details
          </Typography>
        </Paper>
      </Grid>

      <Grid size={6}>
        <Paper variant="outlined" sx={{ p: "13px 14px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1, fontSize: 11 }}>
              QUALIFIED
            </Typography>
            <VerifiedIcon sx={{ color: "#2E7D32", fontSize: 18 }} />
          </Stack>
          <Typography fontWeight={700} sx={{ mt: 0.75, fontSize: 25, color: "#1a1a1a", lineHeight: 1.1 }}>
            {formatInteger(qualified)}
          </Typography>
          <Typography sx={{ color: "#9e9e9e", fontSize: 11, display: "block", mt: 0.5 }}>
            met all criteria
          </Typography>
        </Paper>
      </Grid>

      <Grid size={6}>
        <Paper variant="outlined" sx={{ p: "13px 14px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1, fontSize: 11 }}>
              CONVERSION
            </Typography>
            <TrendingFlatIcon sx={{ color: PRIMARY, fontSize: 18 }} />
          </Stack>
          <Typography fontWeight={700} sx={{ mt: 0.75, fontSize: 25, color: "#1a1a1a", lineHeight: 1.1 }}>
            {formatPercent(conversion, 2)}
          </Typography>
          <Typography sx={{ color: "#9e9e9e", fontSize: 11, display: "block", mt: 0.5 }}>
            user &rarr; qualified
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
